import React, { useState, useEffect } from "react";
import {
  elsevierStyleSheetJSfileImport,
  indianCurrencyFormat,
} from "../library/utils";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import { Link, useParams, useNavigate } from "react-router-dom";

const OrderDetails = () => {
  const { orderNo } = useParams();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState([]);
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    getOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getOrderDetails = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var data = JSON.stringify({
      order_number: orderNo,
    });
    var config = {
      method: "post",
      url: `${backendBookartUrl}/search_order_title?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        let orderDetailsArray = response.data.order_history;
        setOrderDetails(orderDetailsArray);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    //} else {
    //  const valid = await validateJWTtoken(token);
    //  if (!valid) {
    //    navigate("/");
      } else {
        setAuth(true);
      }
    //}
  };

  if (!auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader />
        <div className="container min-height60">
          <Link to="/orderhistory" className="es-link colored font-16">
            <svg viewBox="0 0 54 128" height="16" width="11">
              <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
            </svg>
            &nbsp;Back to Orders
          </Link>
          <div className="margin-top-10p margin-bottom-30">
            <span className="font-36">Order History</span>&nbsp; &nbsp;
          </div>
          {orderDetails.length ? (
            <table className="table table-borderless">
              <thead className="cart-table-header">
                <tr>
                  <td>Order number</td>
                  <td>Title</td>
                  <td>Quantity</td>
                  <td>Total Price</td>
                  <td>Status</td>
                </tr>
              </thead>
              <tbody>
                {orderDetails.map((element, index) => (
                  <tr key={index}>
                    <td className="font-16">{element.order_number}</td>
                    <td className="font-16">{element.title}</td>
                    <td className="font-16">{element.quantity}</td>
                    <td className="font-16">
                      ₹&nbsp;{indianCurrencyFormat(element.total_price)}
                    </td>
                    <td className="font-16">{element.title_status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="container no-result-container">
              <h3>There are no order details for this page</h3>
            </div>
          )}
        </div>
        <Footer />
      </React.Fragment>
    );
  }
};

export default OrderDetails;